/**
 * @file コンポーネント：タブ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Tab = (props) => {
    /**
     * 表示タブ切り替え
     */
    const [selectedTab, setSelectedTab] = useState(props.selectedTab);
    useEffect(() => {
        setSelectedTab(props.selectedTab);
    }, [props.selectedTab]);
    useEffect(() => {
        if (props.setSelectedTab) {
            props.setSelectedTab(selectedTab);
        }
    }, [selectedTab]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
        />
    );
};
